import { render, staticRenderFns } from "./background.vue?vue&type=template&id=16586432&scoped=true"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"
import style0 from "./background.vue?vue&type=style&index=0&id=16586432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16586432",
  null
  
)

export default component.exports